import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const TourTooltip = ({
  continuous,
  index,
  step,
  backProps,
  closeProps,
  primaryProps,
  skipProps,
  tooltipProps,
  isLastStep,
  size,
}) => {
  return (
    <div
      {...tooltipProps}
      className="bg-card rounded-xl border-2 border-primary shadow-2xl p-5 md:p-6 max-w-md animate-slideUp"
    >
      {/* Header */}
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          {step?.title && (
            <h3 className="text-lg md:text-xl font-semibold text-foreground mb-1">
              {step?.title}
            </h3>
          )}
          <div className="flex items-center gap-2 text-xs text-muted-foreground">
            <span>
              Step {index + 1} of {size}
            </span>
            <div className="flex gap-1">
              {Array.from({ length: size })?.map((_, i) => (
                <div
                  key={i}
                  className={`w-1.5 h-1.5 rounded-full transition-colors ${
                    i === index ? 'bg-primary' : 'bg-border'
                  }`}
                />
              ))}
            </div>
          </div>
        </div>
        <button
          {...closeProps}
          className="w-8 h-8 rounded-lg flex items-center justify-center hover:bg-muted transition-colors"
          aria-label="Close tour"
        >
          <Icon name="X" size={16} color="currentColor" />
        </button>
      </div>
      {/* Content */}
      <div className="mb-5">
        <p className="text-sm md:text-base text-foreground leading-relaxed">
          {step?.content}
        </p>
      </div>
      {/* Footer */}
      <div className="flex items-center justify-between gap-3">
        <div>
          {index > 0 && (
            <Button
              {...backProps}
              variant="outline"
              size="sm"
              iconName="ChevronLeft"
            >
              Back
            </Button>
          )}
        </div>
        <div className="flex items-center gap-2">
          {!isLastStep && (
            <Button
              {...skipProps}
              variant="ghost"
              size="sm"
            >
              Skip Tour
            </Button>
          )}
          <Button
            {...primaryProps}
            variant="default"
            size="sm"
            iconName={isLastStep ? 'Check' : 'ChevronRight'}
            iconPosition="right"
          >
            {isLastStep ? 'Finish' : 'Next'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TourTooltip;